import type { Dict } from "../core.js";
import type { ownership as vi } from "../vi/ownership.js";

export const ownership: Dict<typeof vi> = {
  loadFailed: "Couldn't load ownership.",
  assignFailed: "Couldn't assign the owner.",
  createTeamFailed: "Couldn't create the team.",
  title: "Responsibilities",
  intro: "Who is responsible when this breaks — not the same as who can do what in the hub.",
  explain:
    "Owner = the team responsible when a product or service breaks. tier_0/tier_1 items must have an owner — without one they show « No owner » and stay in « Needs attention » until assigned; tier_2/tier_3 are « Optional ». No team yet? Click « Create team », add people on the « Teams » page, then assign it in the last column.",
  createTeam: "Create team",
  missingOwnersAfter:
    " critical items have no owner. Each one is an entry in the « Needs attention » queue, and that entry ",
  missingOwnersStrong: "closes itself",
  missingOwnersEnd: " once an owner is assigned.",
  slug: "Slug",
  teamName: "Team name",
  create: "Create",
  assignAsKind: "Assign as",
  multipleOwners: "Each item can have several owners with different roles.",
  "col.subject": "Item",
  "col.type": "Type",
  "col.tier": "Tier",
  "col.owners": "Current owners",
  "col.assignTeam": "Assign team",
  "type.product": "Product",
  "type.service": "Service",
  noOwner: "No owner",
  noOwnerTitle: "tier_0/tier_1 items must have an owner — assign a team in the last column to close the « Needs attention » entry.",
  notRequired: "Optional",
  notRequiredTitle: "tier_2/tier_3 items don't require an owner — assign one if you like.",
  noTeams: "No teams yet",
  noTeamsTitle: "Click « Create team » at the top of the page to create one first.",
  pickTeam: "Choose a team…",
  noEditPermission: "No permission to edit",
};
